import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormControl, FormControlName, FormGroup, Validators } from '@angular/forms';
import { translate, TranslocoService } from '@ngneat/transloco';

declare var bootstrap: any;

@Component({
  selector: 'app-escalation-edit-wizard',
  templateUrl: './escalation-edit-wizard.component.html',
  styleUrls: ['./escalation-edit-wizard.component.scss']
})
export class EscalationEditWizardComponent implements OnInit {

  @Input() escalation:any = null;
  @Input() type:any = null;
  @Input() id:any = null;
  @Output() completed = new EventEmitter<boolean>();
  steps_html:any = null;

  path = "escalation/company";

  formGroup  = new FormGroup ({
    text: new FormControl('',[]),
  });

  submitted = false;
  step:any = {"type":"","values":{},"error":""};
  step_index:any = null;

  steps:any = [];



  create_step:any = {
    "custom":{
      "custom": ""
    },
    "location":{
			"location": "",
			"who": "",
			"notes": "",
      "last_known":false
		},
    "phonecall":{
      "contact_name": "",
      "contact_number": "",
      "voicemail": "",
      "call_times": "1",
      "wait_time": "1",
      "notes": "",
      "call_worker":false,
      "call_worker_alt":false
		},
  };

  get f(): { [key: string]: AbstractControl } {
    return this.formGroup.controls;
  }


  constructor(public okService: OkAloneService, private transloco: TranslocoService) { }

  ngOnInit(): void {

    //console.log("type",this.type,"id",this.id);



    if(this.type == "worker"){
      this.path = "escalation/worker/"+this.id;
    }else if(this.type == "group"){
      this.path = "escalation/group/"+this.id;
    }

    //console.log(this.escalation);


    if(this.escalation.type == "wizard"){
      this.steps = this.escalation.json;
    }

    //console.log(this.steps);

    this.setHtmlSteps();

  }

  getDefaultStep(step:any){
    let create_step:any = {
      "custom":{
        "custom": ""
      },
      "location":{
        "location": "",
        "who": "",
        "notes": "",
        "last_known":false
      },
      "phonecall":{
        "contact_name": "",
        "contact_number": "",
        "voicemail": "",
        "call_times": "1",
        "wait_time": "1",
        "notes": "",
        "call_worker":false,
        "call_worker_alt":false
      },
    };

    return create_step[step];

  }

  saveEscalation(){


    let values = {escalation: this.steps}
    //console.log('form values',values);

    this.okService.put(this.path,values)
    .subscribe((data) => {


      this.escalation = data.body;

      //console.log(this.escalation);

      this.setHtmlSteps();


    });

    return false;

  }

  setHtmlSteps(){
    this.steps_html = this.escalation.html.split("<!╌ Step End ╌>");
    //console.log(this.steps_html);
  }

  endEditing(){
    this.completed.emit(true);
    return false;

  }


  cancel(){
    this.completed.emit(false);
  }

  newStep(step:string){
    this.step = {"type":step,"values":this.getDefaultStep(step)};
    //console.log(step);
  }

  resetStep(){
    this.step = {"type":"","values":{},"error":""};
    this.step_index = null;
  }

  submitStep(){

    //console.log(this.step);
    this.step.error = "";

    if(this.step.type == "custom"){

      // Validate the step
      let values = this.step.values;
      if(values.custom == ""){
        this.step.error = this.transloco.translate("Please enter a value for your custom step");

      }else{

        let step = {
          "type": "custom",
          "values": {
            "custom": values.custom
          }
        };

        this.saveStep(step);

      }




    }else if(this.step.type == "location"){
      // Validate the step
      let values = this.step.values;

      if(!values.last_known && values.location == ""){

        this.step.error = this.transloco.translate("Please enter a location");


      }else{

        let step = {
          "type": values.last_known ? "location_worker" : "location",
          "values": {
            "location": values.last_known ? null : values.location,
            "who": values.who,
            "notes": values.notes,
          }
        };

        this.saveStep(step);
      }

    }else if(this.step.type == "phonecall"){

      let values = this.step.values;

      if((!values.call_worker && !values.call_worker_alt) && (values.contact_number == "" || values.contact_name == "")){

        this.step.error = this.transloco.translate("Please enter a contact name and number");


      }else{

        let type = "call";
        if(values.call_worker_alt){
          type = "call_worker_alt";
        }else if(values.call_worker){
          type = "call_worker";
        }

        let step = {
          "type": type,
          "values": {
            "contact_name": type=="call" ? values.contact_name : null ,
            "contact_number": type=="call" ? values.contact_number : null ,
            "voicemail": values.voicemail,
            "call_times": values.call_times,
            "wait_time": values.wait_time,
            "notes": values.notes
          }
        };

        this.saveStep(step);


      }
    }


  }

  saveStep(step:any){

    if(this.step_index == null){

      this.steps.push(step);

    }else{

      this.steps[this.step_index] = step;

    }

    //console.log(this.steps);

    this.saveEscalation();

    this.resetStep();

  }


  cancelStep(){
    this.resetStep();
  }

  swap(input: any, index_A: any, index_B: any) {

    if(input[index_B] && input[index_A]){

      let temp = input[index_A];
      //console.log('pre-swap',index_A,index_B);

      input[index_A] = input[index_B];
      input[index_B] = temp;

      //console.log('post-swap',index_A,index_B);
      //console.log('input step', input);

      this.saveEscalation();
    }else{
      //console.log('Cannot swap as not two values');
    }

  }
  removeStep(i:any){
    if(this.steps.length > 1){
      this.steps.splice(i, 1);

      this.saveEscalation();
    }

  }

  setEditStepForm(step:any,index:number){

    //console.log(step);

    this.step_index = index;

    //console.log(this.step_index);

    if(step.type == "custom"){

      this.step = {"type":"custom","values":{
        "custom":step.values.custom
      },"error":""};

      //console.log(this.step);


    }else if(step.type == "location"){

      this.step = {"type":"location","values":{
        "location": step.values.location,
        "who": step.values.who,
        "notes": step.values.notes,
        "last_known":false
      },"error":""};


    }else if(step.type == "location_worker"){

      this.step = {"type":"location","values":{
        "location": "",
        "who": step.values.who,
        "notes": step.values.notes,
        "last_known":true
      },"error":""};

    }else if(step.type == "call"){


      this.step = {"type":"phonecall","values":{
        "contact_name":  step.values.contact_name,
        "contact_number":  step.values.contact_number,
        "voicemail":  step.values.voicemail,
        "call_times":  step.values.call_times,
        "wait_time":  step.values.wait_time,
        "notes":  step.values.notes,
        "call_worker":false,
        "call_worker_alt":false
      },"error":""};



    }else if(step.type == "call_worker"){


      this.step = {"type":"phonecall","values":{
        "contact_name":  null,
        "contact_number":  null,
        "voicemail":  step.values.voicemail,
        "call_times":  step.values.call_times,
        "wait_time":  step.values.wait_time,
        "notes":  step.values.notes,
        "call_worker":true,
        "call_worker_alt":false
      },"error":""};



    }else if(step.type == "call_worker_alt"){


      this.step = {"type":"phonecall","values":{
        "contact_name":  null,
        "contact_number":  null,
        "voicemail":  step.values.voicemail,
        "call_times":  step.values.call_times,
        "wait_time":  step.values.wait_time,
        "notes":  step.values.notes,
        "call_worker":false,
        "call_worker_alt":true
      },"error":""};



    }


  }

}
